import styles from "./SkeletonCard.module.css";

export const SkeletonCard = ({ count = 3 }) => {
    return (
        <div className={styles.carouselContainer}>
            <div className={styles.carouselWrapper}>
                <div className={styles.carousel} style={{ transform: "translateX(0px)", justifyContent: "center" }} >
                    {[...Array(count)].map((_, index) => (
                        <div key={index} className={styles.skeletonCard}>
                            <div className={styles.skeletonHeader}>
                                <div className={styles.skeletonDate}></div>
                                <div className={styles.skeletonLocation}></div>
                            </div>
                            <div className={styles.skeletonContent}>
                                <div className={styles.skeletonTitle}></div>
                                <div className={styles.skeletonDescription}></div>
                                <div className={styles.skeletonDescription}></div>
                                <div className={styles.skeletonDescription}></div>
                            </div>
                            <div className={styles.skeletonActions}>
                                <div className={styles.skeletonDetailsButton}></div>
                                <div className={styles.skeletonApplyButton}></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};